package com.dotdrives.web.pages.forms

import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface PaymentsGateProps : Props {
    var onConnect: () -> Unit
}

/** The full-screen "connect Stripe" gate — design/portal-forms.dc.html's "Payments Gate" frame. */
val PaymentsGate = FC<PaymentsGateProps> { props ->
    div {
        className = ClassName("forms-gate")
        div { className = ClassName("forms-gate-icon"); ariaHidden = true; +"💳" }
        div { className = ClassName("forms-gate-title"); +"One step before your forms go live" }
        div {
            className = ClassName("forms-gate-body")
            +"Connect a Stripe account so gifts land safely in your bank. Takes about 5 minutes — you'll need your EIN and bank details."
        }
        div {
            className = ClassName("forms-gate-points")
            listOf(
                "2.2% + 30¢ nonprofit rate · donors can cover fees",
                "Payouts every 2 business days",
                "Cards, ACH, Apple Pay & Google Pay",
            ).forEach { text ->
                div {
                    className = ClassName("forms-gate-point")
                    span { className = ClassName("forms-gate-check"); ariaHidden = true; +"✓" }
                    span { className = ClassName("forms-gate-point-text"); +text }
                }
            }
        }
        button {
            type = ButtonType.buttonType
            className = ClassName("forms-gate-cta")
            onClick = { props.onConnect() }
            +"Connect with Stripe →"
        }
        div {
            className = ClassName("forms-gate-note")
            +"Forms can be designed now — they publish once Stripe is connected."
        }
    }
}

external interface PaymentsGateBannerProps : Props {
    var onConnect: () -> Unit
}

/** A slimmer inline reminder shown on the dashboard once at least one form already exists. */
val PaymentsGateBanner = FC<PaymentsGateBannerProps> { props ->
    div {
        className = ClassName("forms-gate-banner")
        span { +"Forms can be designed now, but won't accept gifts until Stripe is connected." }
        button {
            type = ButtonType.buttonType
            className = ClassName("forms-gate-banner-btn")
            onClick = { props.onConnect() }
            +"Connect with Stripe →"
        }
    }
}
